const CODIGO_CONCILIACAO_SPED = "CONCILIACAO_SPED";

/**
 * Identifica o relatório Conciliação SPED (Extrator — fluxo dedicado api-relatorios).
 * @param {string | null | undefined} nome
 * @param {string | null | undefined} codigoRelatorio
 * @returns {boolean}
 */
export function isRelatorioConciliacaoSped(nome, codigoRelatorio) {
  const nomeUpper = (nome ?? "").toUpperCase();
  const codigoUpper = (codigoRelatorio ?? "").trim().toUpperCase();
  if (codigoUpper === CODIGO_CONCILIACAO_SPED) {
    return true;
  }
  if (
    nomeUpper.includes("CONCILIA") &&
    (nomeUpper.includes("SPED") || nomeUpper.includes("ECD"))
  ) {
    return true;
  }
  return false;
}
